export default "__VITE_ASSET__D717BYww__"